import { render, staticRenderFns } from "./DifficultyIndicator.vue?vue&type=template&id=22756b0f&scoped=true"
import script from "./DifficultyIndicator.vue?vue&type=script&lang=ts"
export * from "./DifficultyIndicator.vue?vue&type=script&lang=ts"
import style0 from "./DifficultyIndicator.vue?vue&type=style&index=0&id=22756b0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22756b0f",
  null
  
)

export default component.exports